export default function HeartOutline({ ...props }) {
  return (
    <svg
      {...props}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3256 16.5213C14.9985 18.5592 12.6173 19.8646 12.3993 19.9809C12.1812 19.8646 9.79996 18.5592 7.47294 16.5213C5.08291 14.4283 2.95529 11.7404 2.95508 8.90583C2.95665 7.60845 3.47273 6.36465 4.39013 5.44726C5.30752 4.52986 6.55132 4.01378 7.84871 4.01221C9.5089 4.01233 10.9252 4.72255 11.7995 5.88698L12.3993 6.68577L12.999 5.88698C13.8733 4.72255 15.2896 4.01233 16.9498 4.01221C18.2472 4.01378 19.491 4.52986 20.4084 5.44726C21.3259 6.36475 21.842 7.60872 21.8434 8.90626C21.843 11.7407 19.7155 14.4284 17.3256 16.5213Z"
        stroke="#007D32"
        strokeWidth="1.5"
      />
    </svg>
  );
}
